import CommonImage from '@/components/CommonImage';

const DesignImageUpdate = ({ handleDesignUpload, handleCropeImage, selectedImage, isDesignEdit }) => {
	return (
		<div className="teckpack-style">
			<div
				className="image-box"
				onDrop={
					isDesignEdit
						? (e) => {
								handleDesignUpload(
									{ target: { files: e.dataTransfer.files } },
									'PRODUCT_DESIGN'
								);
								e.preventDefault();
							}
						: null
				}
				onDragOver={(e) => e.preventDefault()}
				onDragLeave={(e) => e.preventDefault()}
			>
				<CommonImage src={selectedImage?.docUrl} alt="design" isStatic={false} />
				{isDesignEdit && (
					<>
						<div className="reupload-design">
							<label htmlFor="design-upload" className="drag-upload"></label>
							<input
								type="file"
								className="file-upload d-none"
								id="design-upload"
								accept="image/*"
								multiple
								onChange={handleDesignUpload}
							/>
						</div>
						<div
							className="edit-buttons"
							onClick={(e) => handleCropeImage(e, selectedImage?.id, selectedImage?.docUrl)}
						>
							<img src={`${process.env.PUBLIC_URL}/icons/crop.svg`} alt="crop" />
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default DesignImageUpdate;
